export default {
  state: {
    locations: {
      pickup: {},
      isAirportPickup: false,
      pickupAirport: {},
      pickupAirportReturn: {},
      pickupDetails: {
        pickupTime: {
          leg1: '',
          leg2: ''
        },
        timezone: {
          leg1: '',
          leg2: ''
        },
        eta: '',
        quote: {}
      },
      dropoff: {},
      isAirportDropoff: false,
      dropoffAirport: {},
      dropoffAirportReturn: {},
      dropoffDetails: {
        pickupTime: {
          leg1: '',
          leg2: ''
        },
        timezone: {
          leg1: '',
          leg2: ''
        },
        eta: '',
        quote: {}
      },
      flight: {
        pickup: {},
        dropoff: {}
      }
    }
  },
  mutations: {
    setLocationsData (state, data) {
      for (let field in data) {
        state.locations[field] = data[field]
      }
    },
    setLandPickupTime (state, data) {
      state.locations[data.type].pickupTime[data.leg] = data.val
    },
    setFlightLocationsData (state, data) {
      for (let field in data) {
        state.locations.flight[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/locations.js